/** Реестр обработчиков пресетов. */
class PresetRegistry {
    constructor() {
        this._map = new Map();
    }
    /** Зарегистрировать обработчик по ключу. */
    register(h) {
        this._map.set(h.key, h);
    }
    /** Получить обработчик по ключу. */
    get(key) {
        return this._map.get(key);
    }
    /**
     * Применить зарегистрированные пресеты к списку entries.
     * Возвращает новый список entries (перезапись по schema.key).
     */
    apply(entries) {
        // Индекс по schema.key для перезаписи значений
        const byKey = new Map();
        for (const trigger of entries) {
            const presetKey = trigger.schema.presetKey;
            const k = trigger.schema.key;
            if (!presetKey) {
                // Если нет ключа, то оставляем entry как есть
                byKey.set(k, this._resolve2in1(byKey.get(k), trigger));
                continue;
            }
            const handler = this.get(presetKey);
            if (!handler) {
                // Если хендлер не найден, то оставляем entry как есть
                byKey.set(k, this._resolve2in1(byKey.get(k), trigger));
                continue;
            }
            // Результирующие схемы
            const produced = handler.resolve(trigger, entries);
            // Накладываем результат пресета
            for (const e of produced) {
                const k = e.schema.key;
                byKey.set(k, this._resolve2in1(byKey.get(k), e));
            }
        }
        return Array.from(byKey.values());
    }
    /**
     * Слить два entry в одно (старое + новое).
     */
    _resolve2in1(existing, incoming) {
        if (!existing)
            return incoming;
        // Объединяем только если:
        // - разрешено слияние
        // - поле массивное
        if ((existing.allowJoin || incoming.allowJoin) && existing.schema.isArray) {
            const parse = (v) => (v ?? "")
                .split(",")
                .map(x => x.trim())
                .filter(x => x.length > 0);
            const existingArr = parse(existing.value?.value);
            const incomingArr = parse(incoming.value?.value);
            // distinct + сохранение порядка:
            // сначала старые, затем новые (без дублей)
            const seen = new Set();
            const merged = [];
            for (const v of [...existingArr, ...incomingArr]) {
                if (!seen.has(v)) {
                    seen.add(v);
                    merged.push(v);
                }
            }
            return {
                ...incoming,
                value: {
                    ...incoming.value,
                    value: merged.join(",")
                }
            };
        }
        // По умолчанию — перезапись
        return incoming;
    }
    /**
     * Прогнать decoded-state через пресеты (URL → derived state).
     * Мутирует stateByKey.
     */
    syncFromUrl(scopeEntries, stateByKey) {
        for (const trigger of scopeEntries) {
            const presetKey = trigger.schema.presetKey;
            if (!presetKey)
                continue;
            const key = trigger.schema.key;
            const raw = stateByKey[key];
            const handler = this.get(presetKey);
            if (!handler?.syncFromUrl)
                continue;
            const patch = handler.syncFromUrl(key, raw, scopeEntries, stateByKey);
            if (!patch)
                continue;
            for (const k in patch) {
                stateByKey[k] = patch[k];
            }
        }
    }
    /**
     *  Дополнительная обработка при добавлении параметра фильтра
     */
    onFilterAdded(trigger, value, params) {
        const presetKey = trigger.presetKey;
        if (!presetKey)
            return null;
        const handler = this.get(presetKey);
        if (!handler?.onFilterAdded)
            return null;
        return handler.onFilterAdded(trigger, value, params) ?? null;
    }
}
/** Глобальный реестр (по умолчанию). */
PresetRegistry.default = new PresetRegistry();

export { PresetRegistry };
